import { render, staticRenderFns } from "./InstitutionBanner.vue?vue&type=template&id=4c8c21e6"
import script from "./InstitutionBanner.vue?vue&type=script&lang=js"
export * from "./InstitutionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports